module.exports = __webpack_public_path__ + "static/img/logo-.e65262b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo-.png
// module id = TU8J
// module chunks = 1